/* the othr. — Premium layer scripts
   1) Pack picker drawer for the flavour cards (sections/othr-flavour-grid.liquid)
   2) Gentle scroll reveals ([data-oreveal]) for the new sections
   Add to cart itself is handled by theme.js (any form posting to /cart/add). */
(function () {
  'use strict';

  var html = document.documentElement;
  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function $(sel, root) { return (root || document).querySelector(sel); }
  function $$(sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }

  /* ---------------- Reveal on scroll ---------------- */
  function initReveal() {
    var items = $$('[data-oreveal]:not(.is-in)');
    if (!items.length) return;
    if (reduceMotion || !('IntersectionObserver' in window)) {
      items.forEach(function (el) { el.classList.add('is-in'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-in');
          io.unobserve(entry.target);
        }
      });
    }, { rootMargin: '0px 0px -6% 0px', threshold: 0.12 });
    items.forEach(function (el) { io.observe(el); });
    setTimeout(function () { items.forEach(function (el) { el.classList.add('is-in'); }); }, 5000);
  }

  /* ---------------- Price helpers (for the live total) ---------------- */
  function parseMoney(text) {
    var m = (text || '').replace(/\s+/g, ' ').match(/(\d[\d,]*(?:\.\d+)?)/);
    if (!m) return null;
    var raw = m[1];
    var decimals = raw.indexOf('.') > -1 ? raw.split('.')[1].length : 0;
    return {
      value: parseFloat(raw.replace(/,/g, '')),
      prefix: text.slice(0, text.indexOf(raw)).trim(),
      suffix: text.slice(text.indexOf(raw) + raw.length).trim(),
      decimals: decimals
    };
  }
  function formatMoney(info, amount) {
    var num;
    try {
      num = amount.toLocaleString('en-IN', { minimumFractionDigits: info.decimals, maximumFractionDigits: info.decimals });
    } catch (e) { num = amount.toFixed(info.decimals); }
    return (info.prefix ? info.prefix + ' ' : '') + num + (info.suffix ? ' ' + info.suffix : '');
  }

  /* ---------------- Pack picker drawer ---------------- */
  function PackPicker(section) {
    this.section = section;
    this.drawer = $('[data-ofg-drawer]', section);
    if (!this.drawer) return;
    // Move the drawer to <body> so no parent transform/overflow can clip it.
    this.drawer._ofgOwner = section;
    document.body.appendChild(this.drawer);
    this.panel = $('[data-ofg-panel]', this.drawer);
    this.content = $('[data-ofg-content]', this.drawer);
    this.lastFocus = null;
    this.isOpen = false;
    this.bind();
  }

  PackPicker.prototype.bind = function () {
    var self = this;

    this.section.addEventListener('click', function (e) {
      var opener = e.target.closest('[data-ofg-open]');
      if (!opener) return;
      if (e.metaKey || e.ctrlKey || e.shiftKey || e.button === 1) return; // allow "open in new tab"
      e.preventDefault();
      self.open(opener.getAttribute('data-ofg-open'), opener);
    });

    this.drawer.addEventListener('click', function (e) {
      if (e.target.closest('[data-ofg-close]')) { e.preventDefault(); self.close(); }
    });

    this.drawer.addEventListener('change', function (e) {
      if (e.target.matches('[data-ofg-opt]')) self.select(e.target);
      if (e.target.matches('[data-ofg-qty]')) self.updateTotal();
    });
    this.drawer.addEventListener('input', function (e) {
      if (e.target.matches('[data-ofg-qty]')) self.updateTotal();
    });

    document.addEventListener('keydown', function (e) {
      if (!self.isOpen) return;
      if (e.key === 'Escape') { self.close(); return; }
      if (e.key === 'Tab') self.trapFocus(e);
    });

    // When theme.js opens the cart drawer after a successful add, step aside.
    var cart = $('[data-cart-drawer]');
    if (cart && 'MutationObserver' in window) {
      new MutationObserver(function () {
        if (self.isOpen && cart.classList.contains('is-open')) self.close(true);
      }).observe(cart, { attributes: true, attributeFilter: ['class'] });
    }
  };

  PackPicker.prototype.open = function (blockId, trigger) {
    var tpl = $('template[data-ofg-tpl="' + blockId + '"]', this.section);
    if (!tpl) return;
    this.lastFocus = trigger || document.activeElement;
    this.content.innerHTML = '';
    this.content.appendChild(tpl.content.cloneNode(true));

    var title = $('[data-ofg-title]', this.content);
    if (title) {
      title.id = 'OfgTitle-' + blockId;
      this.panel.setAttribute('aria-labelledby', title.id);
    }

    var checked = $('[data-ofg-opt]:checked', this.content) || $('[data-ofg-opt]:not([disabled])', this.content);
    if (checked) { checked.checked = true; this.select(checked, true); }
    else this.setSoldOut();

    this.drawer.hidden = false;
    this.isOpen = true;
    document.body.classList.add('is-locked', 'ofg-open');
    var self = this;
    requestAnimationFrame(function () {
      requestAnimationFrame(function () { self.drawer.classList.add('is-open'); });
    });
    setTimeout(function () {
      var first = $('[data-ofg-opt]:checked', self.content) || self.panel;
      try { first.focus({ preventScroll: true }); } catch (err) { first.focus(); }
    }, reduceMotion ? 0 : 80);
  };

  PackPicker.prototype.close = function (silent) {
    if (!this.isOpen) return;
    var self = this;
    this.isOpen = false;
    this.drawer.classList.remove('is-open');
    document.body.classList.remove('ofg-open');
    var cart = $('[data-cart-drawer]');
    if (!cart || !cart.classList.contains('is-open')) document.body.classList.remove('is-locked');
    setTimeout(function () {
      if (!self.isOpen) { self.drawer.hidden = true; self.content.innerHTML = ''; }
    }, reduceMotion ? 0 : 420);
    if (!silent && this.lastFocus && this.lastFocus.focus) {
      try { this.lastFocus.focus({ preventScroll: true }); } catch (err) { this.lastFocus.focus(); }
    }
  };

  PackPicker.prototype.select = function (input) {
    var root = this.content;
    var id = input.value;
    var idField = $('[data-ofg-id]', root);
    if (idField) idField.value = id;

    $$('[data-ofg-img]', root).forEach(function (el) {
      el.classList.toggle('is-active', el.getAttribute('data-ofg-img') === id);
    });
    $$('[data-ofg-price]', root).forEach(function (el) {
      el.hidden = el.getAttribute('data-ofg-price') !== id;
    });

    var details = $('[data-ofg-details]', root);
    if (details && input.dataset.url) details.href = input.dataset.url;

    var qty = $('[data-ofg-qty]', root);
    if (qty) {
      var max = parseInt(input.dataset.max, 10) || 99;
      qty.max = max;
      if ((parseInt(qty.value, 10) || 1) > max) qty.value = max;
    }

    var available = input.dataset.available === 'true';
    var add = $('[data-ofg-add]', root);
    if (add) {
      add.disabled = !available;
      var lab = $('[data-add-label]', add);
      var strings = (window.theme && window.theme.strings) || {};
      if (lab) lab.textContent = available ? (strings.addToCart || 'Add to cart') : (strings.soldOut || 'Sold out');
    }
    var stock = $('[data-ofg-stock]', root);
    if (stock) {
      stock.textContent = (available ? 'In stock' : 'Sold out') + ' · ' + (input.dataset.label || '');
      stock.classList.toggle('is-out', !available);
    }
    var err = $('[data-form-error]', root);
    if (err) err.hidden = true;
    this.updateTotal();
  };

  PackPicker.prototype.setSoldOut = function () {
    var add = $('[data-ofg-add]', this.content);
    if (add) add.disabled = true;
    var stock = $('[data-ofg-stock]', this.content);
    if (stock) { stock.textContent = 'Sold out'; stock.classList.add('is-out'); }
  };

  PackPicker.prototype.updateTotal = function () {
    var root = this.content;
    var out = $('[data-ofg-total]', root);
    if (!out) return;
    var visible = $('[data-ofg-price]:not([hidden]) [data-price-current]', root);
    var qtyEl = $('[data-ofg-qty]', root);
    var qty = Math.max(1, parseInt(qtyEl && qtyEl.value, 10) || 1);
    var info = visible ? parseMoney(visible.textContent) : null;
    if (!info || isNaN(info.value)) { out.textContent = ''; return; }
    out.innerHTML = '<span>Total for ' + qty + '</span><strong>' + formatMoney(info, info.value * qty) + '</strong>';
  };

  PackPicker.prototype.trapFocus = function (e) {
    var f = $$('a[href], button:not([disabled]), input:not([disabled]):not([type="hidden"]), [tabindex]:not([tabindex="-1"])', this.panel)
      .filter(function (n) { return n.offsetParent !== null; });
    if (!f.length) return;
    var first = f[0], last = f[f.length - 1];
    if (e.shiftKey && (document.activeElement === first || document.activeElement === this.panel)) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
  };

  // Keep the live total in sync with theme.js quantity steppers.
  document.addEventListener('click', function (e) {
    if (!e.target.closest('.ofg-drawer [data-qty-minus], .ofg-drawer [data-qty-plus]')) return;
    setTimeout(function () {
      pickers.forEach(function (p) { if (p.isOpen) p.updateTotal(); });
    }, 0);
  });

  var pickers = [];
  function init() {
    // Theme editor re-renders: drop drawers whose section is gone.
    $$('body > [data-ofg-drawer]').forEach(function (d) {
      if (d._ofgOwner && !document.body.contains(d._ofgOwner)) d.parentNode.removeChild(d);
    });
    pickers = pickers.filter(function (p) { return document.body.contains(p.section); });
    initReveal();
    $$('[data-ofg-section]').forEach(function (section) {
      if (section._ofg) return;
      section._ofg = new PackPicker(section);
      pickers.push(section._ofg);
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();

  // Theme editor support
  document.addEventListener('shopify:section:load', init);
})();
